import { useQuery } from "@tanstack/react-query";
import axiosManagerRegister from "../services/axiosManagerRegister";

export const useGetYearGroups = () => {
    const {
        isFetching: isLoading, data: yearGroups, error,
    } = useQuery({
        queryKey: ["notionalYearGroup"],
        queryFn: () => axiosManagerRegister.get$("/api/api/notionalYearGroup").then((response) => response?.data),
        initialData: [],
        retry: 0,
    });

    const yearGroupsOptions = (yearGroups || []).map((item) => ({ value: item.notionalYearGroupId, label: item.name }));

    return {
        isLoading, yearGroups, error, yearGroupsOptions,
    };
};
